import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LogisticsAreaProxies } from '../../../services/Ebootis.Queries/LogisticsAreaProxies';
import { LogisticsAreaProxiesOfCompany } from '../../../services/Ebootis.Queries/LogisticsAreaProxiesOfCompany';
import { LogisticsAreaType } from '../../../services/Ebootis.Shared/LogisticsAreaType';
import { LogisticAreaService } from './logistic-area.service';

@Component({
	selector: 'app-logistic-area',
	templateUrl: './logistic-area.component.html',
	styleUrls: ['./logistic-area.component.scss']
})
export class LogisticAreaComponent {

	@Input() public parentForm: UntypedFormGroup;
	@Input() public formCtrlName: string;
	@Input() set forCompany(value: boolean) {
		this.m_forCompany = value;
		this.getData();
	}

	@Input() public set logisticsAreaType(value: LogisticsAreaType) {
		this.m_logisticsAreaType = value;
		this.getData()
	}

	public get logisticsAreaType() {
		return this.m_logisticsAreaType;
	}
	@Output() public areaSelected: EventEmitter<string> = new EventEmitter();
	@Output() public areaSet: EventEmitter<string> = new EventEmitter();
	public readonly LogisticsAreaType = LogisticsAreaType;
	private m_forCompany: boolean;
	public m_selectedArea: string = '';
	private m_logisticsAreaType: LogisticsAreaType = LogisticsAreaType.UNDEF;
	public m_logisticAreas$: Observable<LogisticsAreaProxies.Result[]> = new Observable();

	constructor(
		private m_logisticAreaService: LogisticAreaService,
		private m_logisticForCompany: LogisticsAreaProxiesOfCompany
	) { }

	private getData() {
		if (!this.m_forCompany)
			this.m_logisticAreas$ = this.m_logisticAreaService.getLogisticAreas({ logisticsAreaType: this.m_logisticsAreaType });
		else
			this.m_logisticAreas$ = this.m_logisticForCompany.query({ logisticsAreaType: this.m_logisticsAreaType });
		this.m_logisticAreas$ = this.m_logisticAreas$.pipe(map((list) => {
			return list?.sort((a, b) => {
				if (+a.name > +b.name) // warum wird der name in eine number umgewandelt?
					return 1;
				else if (+a.name < +b.name)
					return -1;
				else return 0;
			});
		})).pipe(tap((res) => {
			if (res && res.length > 0) {
				if (res.length == 1) {
					this.getControl().setValue(res[0].oid);
					this.m_logisticAreaService.setLogisticArea(this.m_logisticsAreaType, res[0].oid);
				} else {
					this.getControl().setValue(this.m_logisticAreaService.getLogisticArea(this.m_logisticsAreaType));
				}
				this.areaSet.emit();
			}
		}));
	}

	/**
	 * Bei einer Änderung der FormControl wird der Inhalt an das aufrufende Component übergeben.
	 * @param p_event ChangeEvent
	 */
	public changedArea(p_event: MatSelectChange): void {
		this.m_selectedArea = p_event.value;
		this.m_logisticAreaService.setLogisticArea(this.m_logisticsAreaType, this.m_selectedArea);
		this.areaSelected.emit(this.m_selectedArea);
	}

	/**
	 * Gibt das FormControl der LogisticArea zurück.
	 */
	public getControl(): AbstractControl {
		return this.parentForm.get('logisticArea');
	}

	/**
	 * Prüft ob das aktuelle FormControl ein Pflichtfeld ist.
	 */
	public isRequiredField(): boolean {
		const form_field: AbstractControl = this.getControl();
		if (!form_field.validator) {
			return false;
		}

		const validator = form_field.validator({} as AbstractControl);
		return (validator && validator.required);
	}

}
